import { render, staticRenderFns } from "./PersonContactDetails.vue?vue&type=template&id=a24107d4"
import script from "./PersonContactDetails.vue?vue&type=script&lang=js"
export * from "./PersonContactDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports